"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fire = exports.off = exports.on = exports.once = void 0;
const once = (eventType, fn) => {
    window.addEventListener(eventType, fn, { once: true });
};
exports.once = once;
const on = (eventType, fn) => {
    window.addEventListener(eventType, fn);
};
exports.on = on;
const off = (eventType, fn) => {
    window.removeEventListener(eventType, fn);
};
exports.off = off;
const fire = (eventType, data) => {
    const event = new CustomEvent(eventType, { detail: data });
    window.dispatchEvent(event);
};
exports.fire = fire;
//# sourceMappingURL=global-events.js.map